import * as React from "react";
export class ViewAllLink extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: "rj-ev-list__view-all-link__wrap", "data-uat": "div-ev-list-view-all-link-wrap" },
            React.createElement("a", { className: "rj-ev-list__view-all-link", href: this.props.href, onClick: (e) => this.props.handler(e, e.target), "data-uat": "a-ev-list-view-all-link" }, this.props.title)));
    }
}
//# sourceMappingURL=ViewAllLink.js.map